import StatusPill, { toneForStatus } from './StatusPill';

export default StatusPill;
export { toneForStatus };
export type { StatusTone } from './StatusPill';
